export default {"src":"/_next/static/media/pair-3.63ce4dc0.svg","height":231,"width":599,"blurWidth":0,"blurHeight":0};